import React from 'react'
import { Link } from 'gatsby'
import { pathLangMap } from 'i18n/urls'

export default ({ to, ...props }) => {
  const lang = process.env.GATSBY_LOCALE
  const translatedPath = lang === 'en' ? to : pathLangMap[lang][to]
  return <Link {...props} to={translatedPath} />
}